import styled from 'styled-components'
import { Layout } from 'antd'
const { Header, Content } = Layout

export const StyledATag = styled.a`
	text-decoration: underline;
	&:hover {
		text-decoration: underline;
	}
`

export const StyledHeader = styled(Header)`
	width: 100%;
	padding-bottom: 32px;
	height: 290px;
	min-height: 120px;
	display: flex;
	justify-content: center;

	background: #fff;

	> a {
		align-self: flex-end;

		img {
			height: 60px; //change to change Logo
			width: auto;
			display: block;
		}
	}
`

export const StyledFooter = styled(Content)`
	display: flex;
	flex-direction: row;
	justify-content: center;
	gap: 24px;
	max-width: 300px;
	margin: auto;
	align-items: center;
	white-space: nowrap;
`
